module.exports = __webpack_public_path__ + "img/2.89e02b61.png";